const REDUCER = "@CATEGORY/";

const actions = {
  GET_LIST_CATEGORY: `${REDUCER}GET_LIST_CATEGORY`,
  SET_LIST_CATEGORY: `${REDUCER}SET_LIST_CATEGORY`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_CATEGORY: `${REDUCER}SET_CURRENT_CATEGORY`,
};
export default actions;
